import api from '../core/common/api';

const settingsService = {
    getAllSettings: async () => {
        const response = await api.call.get('/settings');
        return response.data;
    },

    getSetting: async (settingKey) => {
        const response = await api.call.get(`/settings/${settingKey}`);
        return response.data;
    },

    updateSetting: async (settingKey, settingValue, updatedBy) => {
        const response = await api.call.put(`/settings/${settingKey}`, {
            settingKey,
            settingValue,
            updatedBy
        });
        return response.data;
    },

    getOrganizationSettings: async () => {
        const response = await api.call.get('/organizationsettings');
        return response.data;
    },

    updateOrganizationSettings: async (organizationSettings) => {
        const response = await api.call.put('/organizationsettings', organizationSettings);
        return response.data;
    }
};

export default settingsService;